import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import {
  HeaderComponent,
  FooterComponent
} from '@/components'

export default {
  data () {
    return {
      username: '',
      password: '',
      isLoading: false,
      showPassword: false,
      savePassword: false
    }
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  mounted () {
    this.validateGetPassword()
  },
  methods: {
    ...mapActions([
      'actionSignIn',
      'actionResetPassword'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    login () {
      this.validateSavePassword()

      const params = {
        username: this.username,
        password: this.password,
        applicationAlias: 'support-query'
      }

      this.isLoading = true

      this.actionSignIn(params)
        .then((result) => {
          this.isLoading = false

          this.$router.push({ name: 'Home' })
        }).catch((error) => {
          if (error === 'User or password invalid') {
            this.addToast({
              text: 'Usuário ou senha inválidos.',
              type: 'danger'
            })
          } else if (error === 'Unauthorized') {
            this.addToast({
              text: 'Você não tem permissão para acessar essa aplicação.',
              type: 'warning'
            })
          } else {
            this.addToast({
              text: error,
              type: 'danger'
            })
          }

          this.isLoading = false
        })
    },
    validateGetPassword () {
      const storage = window.localStorage.getItem('pass-support')

      if (storage && JSON.parse(storage).savePassword) {
        this.savePassword = JSON.parse(storage).savePassword
        this.password = JSON.parse(storage).password
        this.username = JSON.parse(storage).username
      }
    },
    validateSavePassword () {
      if (this.savePassword) {
        const password = {
          username: this.username,
          password: this.password,
          savePassword: this.savePassword
        }

        window.localStorage.setItem('pass-support', JSON.stringify(password))
      } else {
        window.localStorage.removeItem('pass-support')
      }
    }
  }
}
